"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForceUpdate = useForceUpdate;
const react_1 = require("react");
function useForceUpdate() {
    const [, updateState] = (0, react_1.useState)();
    return (0, react_1.useCallback)(() => updateState({}), []);
}
